import { TemplateControlType } from 'src/app/modules/management/store/communication-center';
import { DesignControl } from './design-control';
import { TemplateControlService } from './template-control.service';

const displayControlTemplate = `<div style="border-top: 1px solid #d6d5dd; width: 100%; margin-top: 16px; padding-bottom: 8px; height: 2px">&nbsp;</div>`;
const settingsControlTemplate = ``;

export class DividerControl extends DesignControl {
  constructor(document: Document, templateControlService: TemplateControlService) {
    super(document, templateControlService);

    this.controlTemplate = displayControlTemplate;
    this.settingsTemplate = settingsControlTemplate;
    this.controlType = TemplateControlType.Divider;
  }

  public edit(): void {}

  public cancel(): void {}

  public save(): void {}

  public copy(): void {}
}
